import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ActionSource } from "src/app/state/action-sources";

export const JobMutateObjectActions = createActionGroup({
  source: ActionSource.MUTATE_OBJECT_DIALOG,
  events: {
    'Next Button Clicked': props<{ step: string }>(),
    'Previous Button Clicked': props<{ step: string }>(),
    'Review Button Clicked': emptyProps(),
    'Page Indicator Clicked': props<{ step: string }>(),
    'Exit Mutate Object Dialog Button Clicked': emptyProps(),
    'Mutate Button Clicked': emptyProps(),
    'Mutate Button Clicked Error': props<{ error: Error }>(),
    'Review Listbox Item Clicked': props<{ step: string }>(),
    'Enter Key Pressed': props<{ goToStep?: string, mutate?: boolean }>(),
    'Escape Key Pressed': emptyProps(),
  },
})
